div.content-editor!= html

div.controls.clearfix
    a.appcues-style.btn.btn-link.btn-sm.control-link(data-action='delete'): i.fa.fa-trash
    div.warning-message 
        span We found some invalid HTML. Please check and try again.
    a.appcues-style.btn.btn-primary.btn-sm.pull-right(data-action='saveAndClose') Save
    a.appcues-style.btn.btn-default.btn-sm.pull-right(data-action='close') Cancel
